import {QUERY_KEYS} from '@/queryClient'
import {infiniteQueryFetchNextPage} from '@/utilities/helpers'
import {useInfiniteQuery, UseInfiniteQueryOptions} from '@tanstack/react-query'
import {
    httpGetProjectsByPatient,
    HttpGetProjectsByPatientOptions,
    HttpGetProjectsByPatientResponse
} from '../http/projects.http'
import {PatientSmall} from '@/features/patients/types'

export const useGetInfiniteProjectsByPatient = ({
    urlParams,
    params,
    options
}: {
    urlParams: {patientId: PatientSmall['id']}
    params: Omit<HttpGetProjectsByPatientOptions['params'], 'page'>
    options?: Pick<UseInfiniteQueryOptions<HttpGetProjectsByPatientResponse>, 'enabled'>
}) => {
    const query = useInfiniteQuery({
        queryKey: [QUERY_KEYS.PROJECTS_BY_PATIENT, urlParams.patientId, params],
        queryFn: ({pageParam = 1}) =>
            httpGetProjectsByPatient({
                urlParams,
                params: {
                    ...params,
                    page: pageParam
                }
            }),
        ...options,
        initialPageParam: 1,
        getNextPageParam: ({meta}) => (meta.currentPage < meta.lastPage ? meta.currentPage + 1 : null)
    })

    return {
        ...query,
        fetchNextPage: () => infiniteQueryFetchNextPage(query),
        remappedData: query.data?.pages[0]?.data?.length ? query.data.pages.flatMap(page => page.data) : []
    }
}
